(function () {
  const root = document.querySelector("[data-postcards-page]");
  if (!root) return;

  const discoveryPoints = root.querySelectorAll(".ootb-discovery-point");
  const linePath = root.querySelector("#connection-path");
  const boxSection = root.querySelector("#box");

  function updateDiscoveryVisuals(item) {
    if (!item || !linePath || !boxSection) return;

    const type = item.dataset.point;
    const targetX = parseFloat(item.dataset.x || "0");
    const targetY = parseFloat(item.dataset.y || "0");

    root.querySelectorAll(".hotspot-wrapper").forEach((hotspot) => {
      hotspot.classList.remove("active");
    });

    const activeHotspot = root.querySelector("#hotspot-" + type);
    if (activeHotspot) {
      activeHotspot.classList.add("active");
    }

    const itemRect = item.getBoundingClientRect();
    const sectionRect = boxSection.getBoundingClientRect();
    const startX = itemRect.right - sectionRect.left;
    const startY = itemRect.top + itemRect.height / 2 - sectionRect.top;
    const endX = (targetX / 100) * sectionRect.width;
    const endY = (targetY / 100) * sectionRect.height;
    const curveIntensity = Math.abs(endX - startX) * 0.5;

    linePath.classList.remove("active");
    void linePath.offsetWidth;
    linePath.setAttribute(
      "d",
      "M " +
        startX +
        "," +
        startY +
        " C " +
        (startX + curveIntensity) +
        "," +
        startY +
        " " +
        (endX - curveIntensity) +
        "," +
        endY +
        " " +
        endX +
        "," +
        endY
    );
    linePath.classList.add("active");

    discoveryPoints.forEach((point) => {
      const icon = point.querySelector(".material-symbols-outlined");
      if (icon) {
        icon.textContent = point === item ? "remove" : "add";
      }
    });
  }

  discoveryPoints.forEach((item) => {
    item.addEventListener("click", () => {
      if (item.classList.contains("active")) return;

      discoveryPoints.forEach((point) => {
        point.classList.remove("active");
        point.style.opacity = "0.5";
      });

      item.classList.add("active");
      item.style.opacity = "1";
      // updateDiscoveryVisuals(item);
    });
  });

  const desktopScroller = root.querySelector("#gallery-scroller");
  const desktopScrollButton = root.querySelector("#scroll-right");
  const desktopScrollButtonLeft = root.querySelector("#scroll-left");
  const desktopScrollButtonContainer = desktopScrollButton ? desktopScrollButton.closest(".scroll-arrow-container") : null;
  const desktopScrollButtonLeftContainer = desktopScrollButtonLeft
    ? desktopScrollButtonLeft.closest(".scroll-arrow-container")
    : null;

  function setDesktopButtonVisible(container, isVisible) {
    if (!container) return;

    container.style.opacity = isVisible ? "1" : "0";
    container.style.pointerEvents = isVisible ? "auto" : "none";
    container.setAttribute("aria-hidden", isVisible ? "false" : "true");
  }

  function updateDesktopSliderButtons() {
    if (!desktopScroller || !desktopScrollButtonContainer || !desktopScrollButtonLeftContainer) return;

    const isAtStart = desktopScroller.scrollLeft <= 1;
    const isAtEnd = desktopScroller.scrollLeft + desktopScroller.clientWidth >= desktopScroller.scrollWidth - 1;

    setDesktopButtonVisible(desktopScrollButtonLeftContainer, !isAtStart);
    setDesktopButtonVisible(desktopScrollButtonContainer, !isAtEnd);
  }

  function scheduleDesktopSliderButtonUpdate() {
    window.requestAnimationFrame(updateDesktopSliderButtons);
    window.setTimeout(updateDesktopSliderButtons, 350);
  }

  if (desktopScroller && desktopScrollButton && desktopScrollButtonLeft) {
    desktopScrollButton.addEventListener("click", () => {
      desktopScroller.scrollBy({ left: 400, behavior: "smooth" });
      scheduleDesktopSliderButtonUpdate();
    });

    desktopScrollButtonLeft.addEventListener("click", () => {
      desktopScroller.scrollBy({ left: -400, behavior: "smooth" });
      scheduleDesktopSliderButtonUpdate();
    });

    desktopScroller.addEventListener("scroll", updateDesktopSliderButtons);
    updateDesktopSliderButtons();
  }

  const faqItems = root.querySelectorAll(".desktop-version .faq-item");
  faqItems.forEach((item) => {
    item.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      faqItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("active");
        }
      });

      item.classList.toggle("active", !isActive);
    });
  });

  const mobileSlider = root.querySelector("#postcard-slider");
  const mobilePrevButton = root.querySelector("#scroll-prev");
  const mobileNextButton = root.querySelector("#scroll-next-btn");

  function mobileScrollAmount() {
    if (!mobileSlider) return 300;

    const firstCard = mobileSlider.querySelector(":first-child");
    if (!firstCard) return 300;

    const style = window.getComputedStyle(mobileSlider);
    const gap = parseInt(style.columnGap || style.gap || "24", 10) || 24;
    return firstCard.offsetWidth + gap;
  }

  function updateMobileSliderButtons() {
    if (!mobileSlider || !mobilePrevButton || !mobileNextButton) return;

    const isAtStart = mobileSlider.scrollLeft <= 0;
    const isAtEnd = mobileSlider.scrollLeft + mobileSlider.clientWidth >= mobileSlider.scrollWidth - 1;

    mobilePrevButton.style.opacity = isAtStart ? "0.3" : "1";
    mobilePrevButton.style.pointerEvents = isAtStart ? "none" : "auto";
    mobileNextButton.style.opacity = isAtEnd ? "0.3" : "1";
    mobileNextButton.style.pointerEvents = isAtEnd ? "none" : "auto";
  }

  if (mobileSlider && mobilePrevButton && mobileNextButton) {
    mobileNextButton.addEventListener("click", () => {
      mobileSlider.scrollBy({ left: mobileScrollAmount(), behavior: "smooth" });
    });

    mobilePrevButton.addEventListener("click", () => {
      mobileSlider.scrollBy({ left: -mobileScrollAmount(), behavior: "smooth" });
    });

    mobileSlider.addEventListener("scroll", updateMobileSliderButtons);
    updateMobileSliderButtons();
  }

  root.querySelectorAll(".pulse-ring").forEach((ring) => {
    ring.addEventListener("mouseenter", () => {
      ring.style.animationPlayState = "paused";
    });

    ring.addEventListener("mouseleave", () => {
      ring.style.animationPlayState = "running";
    });
  });

  window.addEventListener("resize", () => {
    const activePoint = root.querySelector(".ootb-discovery-point.active");
    if (activePoint) {
      // updateDiscoveryVisuals(activePoint);
    }
    updateDesktopSliderButtons();
    updateMobileSliderButtons();
  });

  window.setTimeout(() => {
    const firstPoint = root.querySelector(".ootb-discovery-point.active") || root.querySelector(".ootb-discovery-point");
    if (firstPoint) {
      // updateDiscoveryVisuals(firstPoint);
    }
  }, 300);
})();
